
const ElementCollection = require('./index');

module.exports = function (selector, context) {
  return new ElementCollection(selector, context);
};
